import { ResourcesAllocateForm } from '@components/Resources/Allocate/ResourcesAllocateForm';
import { ResourcesAllocateResults } from '@components/Resources/Allocate/ResourcesAllocateResults';
import { ganttDayFormat } from '@components/Schedule/Gantt/gantt.constants';
import { DaySlotResourcesAllocationDto, useMutationPostAutoAllocateDaySlotResources } from '@models';
import { format as originalFormat } from 'date-fns';
import React, { memo, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';

import { errorToastConfig } from '../../../config/constants';
import { useCurrentUserResources } from '../../../contexts/OidcContext/OidcContext.selectors';
import { useUiValue } from '../../../contexts/UiContext';

export const ResourcesAllocatePopin = memo(function ResourcesAllocatePopin({ onClose }: { onClose: () => void }) {
    const selectedDate = useUiValue('selectedDate');
    const clientResources = useCurrentUserResources();

    const {
        mutateAsync: autoAllocate,
        data: allocationResponse,
        isLoading,
    } = useMutationPostAutoAllocateDaySlotResources({
        onError: () => {
            toast(<FormattedMessage id={'schedule.allocate.errorToast'} />, errorToastConfig);
        },
    });

    const onSubmit = useCallback(
        (values: DaySlotResourcesAllocationDto) => {
            autoAllocate({
                daySlotResourcesAllocationDto: values,
            });
        },
        [autoAllocate],
    );

    const resourcesAllocateFormInitialValues = useMemo(
        () => ({
            day: originalFormat(selectedDate, ganttDayFormat),
            resourceType: clientResources?.[0]?.type || '',
            allocateFromScratch: false,
        }),
        [clientResources, selectedDate],
    );

    return allocationResponse ? (
        <ResourcesAllocateResults results={allocationResponse} onClose={onClose} />
    ) : (
        <ResourcesAllocateForm
            onSubmit={onSubmit}
            onClose={onClose}
            isLoading={isLoading}
            initialValues={resourcesAllocateFormInitialValues}
        />
    );
});
